var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.$style.root},[_c('div',{staticClass:"scroll-wrapper"},[_c('div',{staticClass:"screen-main"},[_c('Heading',[_vm._v("农机作业大数据管理平台")]),_c('div',{staticClass:"screen-body"},[_c('Panel1'),_c('Panel2'),_c('Panel3'),_c('Panel4')],1)],1),_c('Panel5',{staticClass:"screen-side"})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }